// /reviews page network layer. Both endpoints live on the customer
// middleware (`api/src/Controllers/OrderController`), which proxies to
// essay-db (`/customer-api/writer/feedbacks` for the list, and
// `/customer-api/orders/{n}/review` for the submit).

export async function fetchFeedbacks() {
    const res = await fetch('/api/writer/feedbacks', {
        method: 'GET',
        credentials: 'include',
        headers: {Accept: 'application/json'},
    });
    if (!res.ok) {
        throw new Error('Failed to load feedbacks');
    }
    const json = await res.json();
    return Array.isArray(json?.data) ? json.data : [];
}

// Submit body matches the legacy /core/order/review payload so
// the existing middleware handler (actionReview) keeps working
// regardless of which surface (legacy jQuery or new React) calls it.
export async function submitReview({orderId, rate, message}) {
    const res = await fetch('/api/order/review', {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({order_id: orderId, rate, message}),
    });
    let json = null;
    try { json = await res.json(); } catch (_) { /* non-JSON */ }

    if (!res.ok || json?.errors) {
        const err = new Error('Submit failed');
        err.errors = json?.errors || null;
        err.status = res.status;
        throw err;
    }
    return json;
}
